import { render, staticRenderFns } from "./HeaderInformationNavigationBbg.vue?vue&type=template&id=266b30f2&scoped=true"
import script from "./HeaderInformationNavigationBbg.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationBbg.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationBbg.vue?vue&type=style&index=0&id=266b30f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266b30f2",
  null
  
)

export default component.exports